import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { NATIVE_FIELD_CLASS } from '@/contabilidad/constants/ui';

interface DateInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export function DateInput({ error, className, ...props }: DateInputProps) {
  return (
    <input
      type="date"
      className={cn(NATIVE_FIELD_CLASS, error && 'border-rose-500', className)}
      {...props}
    />
  );
}
